import {loadScripts} from "./helpers/loaderHelpers";

console.log("loader version",'1.1.40');
window.addEventListener('load', loadScripts());


// WEBPACK FOOTER //
// ./src/loader/index.js